import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { checkPlaceSuggestion } from "api/formDisplay";
import Label from "lib/Label";

const InputSuggestion = (props) => {
  const {
    tooltip,
    label,
    onChange,
    name,
    size,
    error,
    selectedData = {}, 
    validators,
    setSelectedData,
    autofill,
    formErr,
    clearFieldError,
    suggestion_type,
  } = props;
  const [inputValue, setInputValue] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [messageToast, setMessageToast] = useState({ type: "", msg: "" });
  const dispatch = useDispatch();
  let suggestionData;

  const placePrediction = async (data) => {
    let result;
    if (data.length !== "") {
      let key = data;

      result = await checkPlaceSuggestion({ key, suggestion_type });
      if (result?.status === "success") {
        suggestionData = result.data;
        const message = result?.message
          ? result?.message
          : "Suggestion fetched successfully";
        setMessageToast({ type: "success", msg: message });
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
      } else {
        dispatch(setSelectedData({ key: name, value: "" }));
        const errorMessage = result?.message
          ? result?.message
          : "Invalid Input, Please enter a valid text";
        setMessageToast({ type: "error", msg: errorMessage });
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
      }
    }
  };

  const handleInputChange = async (event) => {
    const value = event.target.value.toLowerCase();
    setInputValue(value);
    dispatch(
      setSelectedData({
        key: name,
        value: value,
      })
    );
    await placePrediction(value);

    // Filter suggestions based on the fetched suggestionData
    const filteredSuggestions = suggestionData.filter((suggestion) =>
      suggestion.description.toLowerCase().includes(value)
    );
    setSuggestions(filteredSuggestions);
    setShowSuggestions(true);
    onChange(event);
  };

  const handleSuggestionClick = (selectedSuggestion,suggestion_type) => {
    setInputValue(selectedSuggestion);
    if(suggestion_type == 'placeSuggestion'){
      
      dispatch(
        setSelectedData({
          key: name + "_location",
          value: selectedSuggestion,
        })
      );
      if (selectedSuggestion.split(",").length == 3) {
        dispatch(
          setSelectedData({
            key: name + "_city",
            value: selectedSuggestion.split(",")[0],
          })
        );
        dispatch(
          setSelectedData({
            key: name + "_state",
            value: selectedSuggestion.split(",")[1],
          })
        );
        dispatch(
          setSelectedData({
            key: name + "_country",
            value: selectedSuggestion.split(",")[2],
          })
        );
      } else if (selectedSuggestion.split(",").length < 3) {
        dispatch(
          setSelectedData({
            key: name + "_state",
            value: selectedSuggestion.split(",")[0],
          })
        );
        dispatch(
          setSelectedData({
            key: name + "_country",
            value: selectedSuggestion.split(",")[1],
          })
        );
      } else {
        const suggestionArray = selectedSuggestion.split(",");
  
        const lastTwoElements = suggestionArray.slice(-2);
  
        dispatch(
          setSelectedData({ key: name + "_state", value: lastTwoElements[0] })
        );
        dispatch(
          setSelectedData({ key: name + "_country", value: lastTwoElements[1] })
        );
      }
    }else{
      dispatch(
        setSelectedData({
          key: name,
          value: selectedSuggestion,
        })
      );
    }
    setShowSuggestions(false);
  };
  useEffect(() => {
    autofill?.map((item) => {
      dispatch(
        setSelectedData({
          key: [item.destination_field],
          value: selectedData[item.source_field],
        })
      );
    });
  }, [showSuggestions]);

  useEffect(() => {
    if (selectedData && formErr) {
      let errorKeys = Object.keys(formErr);
      errorKeys.forEach((item) => {
        if (Object.keys(selectedData)?.includes(item)) {
          clearFieldError(item);
        }
      });
    }
  }, [selectedData]);

  return (
    <div className={size}>
      <div className="position">
        {label ? (
          <Label label={label} tooltip={tooltip} validators={validators} />
        ) : (
          <div className="mt-2" />
        )}
        <input
          type="text"
          className={`form-input ${errorClass}`}
          value={
            inputValue == null ? selectedData.other_place_location : inputValue
          }
          onChange={handleInputChange}
        />
        {showSuggestions && (
          <ul className="suggestions-list">
            {suggestions.map((suggestion, index) => (
              <li
                key={index}
                onClick={() => handleSuggestionClick(suggestion.description,suggestion_type)}
                style={{ cursor: "pointer" }}
              >
                {suggestion.description}
              </li>
            ))}
          </ul>
        )}
        {error?.length !== 0 && <ErrorMessage error={error} />}
      </div>
    </div>
  );
};

export default InputSuggestion;
